import React from 'react';
import source from './fire.md';
import Md2Jsx from '../../components/Md2Jsx/Md2Jsx';

export default function Fire() {
  return <Md2Jsx source={source} />;
}
